import { useEffect, useState } from 'react';
import {
    Grid,
    FormControl,
    FormLabel,
    FormGroup,
    Slider,
    TextField,
    InputAdornment,
} from '@mui/material';
import {
    timeStringToDate,
    dateToTimeFormat24,
} from 'utilities';
import { TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

export function Sliders({
    label,
    value,
    onChange,
    min,
    max,
    step,
    inputLabels = ['Min', 'Max'],
    inputAdornment = '',
    formatValue = (v) => v,
    parseValue = (v) => Number(v),
    showInputs = true,
    state,
    setState
}) {
    const [localValue, setLocalValue] = useState(value);

    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    const handleSliderChange = (_, newValue) => {
        setLocalValue(newValue);
        onChange(newValue);
    };

    const handleInputChange = (index, e) => {
        const newVal = [...localValue];
        newVal[index] = parseValue(e.target.value);
        setLocalValue(newVal);
        onChange(newVal);
    };

    return (
        <FormControl fullWidth component="fieldset" variant="standard" sx={{ mt: 2 }}>
            <FormLabel>{label}</FormLabel>
            <FormGroup>
                <Grid container spacing={1}>
                    <Grid size={{ xs: 12, md: 6, sm: 12 }} sx={{ pr: { xs: 0, md: 1 } }}>
                        <Slider
                            value={localValue}
                            onChange={handleSliderChange}
                            valueLabelDisplay="auto"
                            min={min}
                            max={max}
                            step={step}
                            valueLabelFormat={formatValue}
                            getAriaValueText={formatValue}
                        />
                    </Grid>
                    {showInputs ? (
                        <>
                            <Grid size={{ xs: 12, md: 3, sm: 6 }}>
                                <TextField
                                    label={inputLabels[0]}
                                    value={localValue[0]}
                                    onChange={(e) => handleInputChange(0, e)}
                                    fullWidth
                                    slotProps={{
                                        input: {
                                            startAdornment: inputAdornment && (
                                                <InputAdornment position="start">{inputAdornment}</InputAdornment>
                                            ),
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 3, sm: 6 }}>
                                <TextField
                                    label={inputLabels[1]}
                                    value={localValue[1]}
                                    onChange={(e) => handleInputChange(1, e)}
                                    fullWidth
                                    slotProps={{
                                        input: {
                                            startAdornment: inputAdornment && (
                                                <InputAdornment position="start">{inputAdornment}</InputAdornment>
                                            ),
                                        },
                                    }}
                                />
                            </Grid>
                        </>
                    ) : (
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <Grid size={{ xs: 12, md: 3, sm: 6 }}>
                                <TimePicker
                                    label="Start"
                                    value={timeStringToDate(state.availableTimeMinimum)}
                                    onChange={(val) =>
                                        setState((prev) => ({
                                            ...prev,
                                            availableTimeMinimum: dateToTimeFormat24(val),
                                        }))
                                    }
                                    slots={{
                                        openPickerIcon: () => null
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            variant: 'outlined',
                                            size: 'medium'
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, md: 3, sm: 6 }}>
                                <TimePicker
                                    label="End"
                                    value={timeStringToDate(state.availableTimeMaximum)}
                                    onChange={(val) =>
                                        setState((prev) => ({
                                            ...prev,
                                            availableTimeMaximum: dateToTimeFormat24(val),
                                        }))
                                    }
                                    slots={{
                                        openPickerIcon: () => null
                                    }}
                                    slotProps={{
                                        textField: {
                                            fullWidth: true,
                                            variant: 'outlined',
                                            size: 'medium'
                                        }
                                    }}
                                />
                            </Grid>
                        </LocalizationProvider>
                    )}
                </Grid>
            </FormGroup>
        </FormControl>
    );
};